import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full px-4 pt-10 pb-12 max-w-3xl mx-auto" data-id="element-55">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center space-y-6" data-id="element-56">
        <h2 className="font-handwriting text-4xl md:text-5xl lg:text-6xl text-forest font-bold leading-tight" data-id="element-57">
          "Nach der Antibiotika-Kur war Rocky nicht mehr er selbst – bis ich das
          entdeckte"
        </h2>

        <p className="font-serif text-lg md:text-xl text-brown/90 max-w-2xl mx-auto leading-relaxed" data-id="element-58">
          Wie ich Rockys Darmflora auf natürlichem Weg wieder aufgebaut habe.
        </p>

        <div className="relative mt-8 rounded-2xl overflow-hidden shadow-paper border-4 border-white rotate-1" data-id="element-59">
          <img src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&q=80&w=1000" alt="Rocky, ein müder aber liebenswerter Hund" className="w-full h-auto object-cover aspect-[4/3] md:aspect-[16/9]" data-id="element-60" />
          <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent mix-blend-multiply" data-id="element-61"></div>
        </div>
      </motion.div>
    </section>;
}